import React, { useState, useEffect } from 'react';
import { db } from '../firebaseConfig';
import { collection, query, where, onSnapshot, orderBy } from 'firebase/firestore';
import PriceComparison from '../components/PriceComparison';
import SearchAndFilterBar from '../components/SearchAndFilterBar';

const ComparisonList = ({ user }) => {
    const [allProducts, setAllProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    const [searchTerm, setSearchTerm] = useState('');
    
    const [showComparison, setShowComparison] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);

    useEffect(() => {
        if (!user) return;
        
        const productQuery = query(
            collection(db, "products"), 
            where("userId", "==", user.uid),
            where("linkedProductId", "!=", ""),
            orderBy("linkedProductId"),
            orderBy("createdAt", "desc")
        );
        const unsubscribe = onSnapshot(productQuery, (querySnapshot) => {
            const productsData = querySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
            setAllProducts(productsData);
            setFilteredProducts(productsData);
            setLoading(false);
        }, (err) => {
            console.error("Error fetching linked products:", err);
            setError("Could not load data. A new Firestore index might be required. Please check the console.");
            setLoading(false);
        });
        return () => unsubscribe();
    }, [user]);

    useEffect(() => {
        let results = allProducts;
        if (searchTerm) {
            results = results.filter(p => 
                p.itemName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                p.productId.toLowerCase().includes(searchTerm.toLowerCase()) ||
                p.linkedProductId.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }
        setFilteredProducts(results);
    }, [searchTerm, allProducts]);

    const handleShowComparison = (product) => {
        setSelectedProduct(product);
        setShowComparison(true);
    };

    if (loading) return <p>Loading comparison list...</p>;
    if (error) return <p style={{ color: 'var(--brand-danger)' }}>{error}</p>;

    return (
        <>
            {showComparison && (
                <PriceComparison 
                    user={user}
                    currentProduct={selectedProduct} 
                    linkedProductId={selectedProduct.linkedProductId} 
                    onClose={() => setShowComparison(false)}
                />
            )}
            <div className="product-list-container">
                <div className="page-header">
                    <h2>Comparison List</h2>
                    <SearchAndFilterBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} filters={{}} setFilters={() => {}} />
                </div>
                {filteredProducts.length === 0 ? (
                    <p>No products with linked IDs found.</p>
                ) : (
                    <div className="table-wrapper">
                        <table className="product-list-table">
                            <thead>
                                <tr>
                                    <th>Current Product ID</th>
                                    <th>Item Name</th>
                                    <th>Linked Product ID</th>
                                    <th>Unit Cost (RM)</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredProducts.map(product => (
                                    <tr key={product.id}>
                                        <td>{product.productId}</td>
                                        <td>{product.itemName}</td>
                                        <td>{product.linkedProductId}</td>
                                        <td>{product.perUnitCostMYR.toFixed(2)}</td>
                                        <td className="cell-actions">
                                            <button className="submit-button" onClick={() => handleShowComparison(product)}>
                                                Show Comparison
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </>
    );
};

export default ComparisonList;
